export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-TravelCityMultipleSelector',
            name: 'admin-yinzhilv-demo-TravelCityMultipleSelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-TravelCityMultipleSelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-TravelCityMultipleSelector`},
                ],
            },
        },
    ],
};
